import { quotation as QuotationApi } from '@teem/constants/api';
import { getAcronym } from '@teem/helpers/functions';
import * as moment from 'moment';

export default class DraftsTableSchema {
	keyColumn: string = 'uuid';
	userInfo: any = (window as any).userInfo;
	serverUrl: string = `${QuotationApi.all}?is_draft=1`;
	containerContext: any;
	headers: Array<object> = [
		{ "label": "#", "thClass": "th-number" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
		{ "label": $localize`:@@ts.client:Client`, "thClass": "th-client" },
		{ "label": $localize`:@@ts.project_name:Project Name`, "thClass": "th-project" },
		{ "label": $localize`:@@ts.amount:Amount`, "thClass": "th-amount" },
	];
	cols: Array<object> = [
		{ "key": "quotation_number", "tdClass": "td-number" },
		{
			"key": "quotation_date", "tdClass": "td-date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (
						`<div class="date">
								<span class="day">${d.format('DD')}</span>
								<span class="month">${d.format('MMM')}</span>
								<span class="year">${d.format('YYYY')}</span>
						</div>`)
						;
				}

				return '';
			}
		},
		{ "key": "client_name", "tdClass": "td-client-name" },
		{ "key": "title", "tdClass": "td-project-name" },
		{ 
			"key": "sub_total", 
			"tdClass": "td-amount", 
			// "render": (value) => { return this.containerContext.currencyPipe.transform(value ? value : 0) } },
			"render": (value, row) => {
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
				return `<div class="amount">
							<span class="sar">${currency}</span>
							<span class="price">${value ? value : 0}</span>							
						</div>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0)
			}
		}
	];

	constructor(container: any) {
		this.containerContext = container;
	}
}
